{
    "ComparisonTypeLabel": "Quand :",
    "ComparisonTypeOptionNone": "[Pas d'alarme]",
    "ComparisonTypeOptionHigherThan": "Plus haut que",
    "ComparisonTypeOptionHigherEqual": "Supérieur\/Egal",
    "ComparisonTypeOptionLowerThan": "Plus bas que",
    "ComparisonTypeOptionLowerEqual": "inférieur\/égal",
    "ComparisonTypeOptionBetween": "Entre",
    "ComparisonTypeOptionEqual": "Equal",
    "ComparisonTypeOptionNotEqual": "Non égal",
    "ComparisonTypeOptionNotBetween": "Pas entre",
    "ComparisonTypeValue": "Valeur :",
    "ComparisonTypeAnd": "Et",
    "AlarmTypeLabel": "Type d'alarme :",
    "AlarmTypeNoSound": "[Pas de son]",
    "AlarmTypeAirRaidSiren": "Sirène de raid aérien",
    "AlarmTypeAlarmClock": "Réveil",
    "AlarmTypeDing": "Ding",
    "AlarmTypeDoorChime": "Carillon de porte",
    "AlarmTypeEmergencyServices": "Services d'urgence",
    "AlarmTypeFastenSeatBelt": "Attacher la ceinture de sécurité",
    "AlarmTypeKerching": "Kerching",
    "AlarmTypePhone": "Téléphone",
    "AlarmTypeQuickBleep": "Quick Bleep",
    "AlarmTypeRadar": "Radar",
    "AlarmTypeSonarPing": "Sonar Ping",
    "AlarmTypeTarget": "Cible",
    "AlarmTypeTing": "Ting",
    "AlarmTypeWarningBeep": "Bip d'avertissement",
    "AlarmTypeWarningBuzzer": "Buzzer d'avertissement",
    "AlarmRepeatTypeLabel": "Type de lecture :",
    "AlarmRepeatOnce": "Une fois",
    "AlarmRepeatSeconds": "Secondes",
    "AlarmRepeatPersistent": "Persistant",
    "AlarmRepeatRepeat": "Répéter",
    "AlarmSettingsLabel": "Valeur :",
    "StatisticAlarm_SectionHeader": "Alarme statistique",
    "NAME": "StatisticAlarm",
    "AlarmType_Air Raid Siren": "Sirène de raid aérien",
    "AlarmType_Alarm Clock": "Réveil",
    "AlarmType_Barking": "Barking",
    "AlarmType_Birds": "Oiseaux",
    "AlarmType_Cat": "Chat",
    "AlarmType_Chips": "Chips",
    "AlarmType_Coin Drop": "Chute de pièces",
    "AlarmType_Computer": "Ordinateur",
    "AlarmType_Cow": "Vache",
    "AlarmType_Crowd": "Foule",
    "AlarmType_Dial Tone": "Tonalité",
    "AlarmType_Ding": "Ding",
    "AlarmType_Dixie Horn": "Dixie Horn",
    "AlarmType_Door Chime": "Carillon de porte",
    "AlarmType_Emergency Services": "Services d'urgence",
    "AlarmType_Fasten Seat Belt": "Attacher la ceinture de sécurité",
    "AlarmType_Fire Truck": "Camion de pompiers",
    "AlarmType_Gunshot": "Coup de feu",
    "AlarmType_Hammer": "Marteau",
    "AlarmType_Helicopter": "Hélicoptère",
    "AlarmType_Ice Cubes": "Glaçons",
    "AlarmType_Kerching": "Kerching",
    "AlarmType_Laughter": "Rires",
    "AlarmType_Marbles": "Marbres",
    "AlarmType_Monkey": "Singe",
    "AlarmType_Morse Code": "Code Morse",
    "AlarmType_Night Time": "Heure de la nuit",
    "AlarmType_Owl": "Hibou",
    "AlarmType_Phone": "Téléphone",
    "AlarmType_Pool": "Piscine",
    "AlarmType_Pouring Water": "Verser de l'eau",
    "AlarmType_Quick Bleep": "Bip rapide",
    "AlarmType_Radar": "Radar",
    "AlarmType_Reload": "Recharge",
    "AlarmType_Rocks Falling": "Chute de pierres",
    "AlarmType_Rooster": "Coq",
    "AlarmType_Sawing": "Sciage",
    "AlarmType_School Bell": "Cloche de l'école",
    "AlarmType_Seaguls": "Mouettes",
    "AlarmType_Service Bell": "Cloche de service",
    "AlarmType_SMS": "SMS",
    "AlarmType_Sonar Ping": "Sonar Ping",
    "AlarmType_Splash": "Éclaboussures",
    "AlarmType_Steam Train": "Train à vapeur",
    "AlarmType_Submarine": "Sous-marin",
    "AlarmType_Target": "Cible",
    "AlarmType_Thunder": "Tonnerre",
    "AlarmType_Ting": "Ting",
    "AlarmType_Tolling Bell": "Cloche à péage",
    "AlarmType_Trombone": "Trombone",
    "AlarmType_Twinkle": "Scintillement",
    "AlarmType_Walking": "La marche",
    "AlarmType_Whistling": "Sifflement",
    "AlarmType_Warning Beep": "Bip d'avertissement",
    "AlarmType_Warning Buzzer": "Avertisseur sonore"
}